module.exports = __webpack_public_path__ + "static/lifeworks-logo-en-f921a6c5ec6f5cc23b4f7a89c790678a.png";